import React from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../contant";
import Navbar from "../components/navbar";
import Footur from "../components/footur";
const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Navbar />

      {/* Content Wrapper */}
      <div className="flex justify-center py-4 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-[90%] sm:max-w-4xl bg-white rounded-2xl p-4 sm:p-6">
          {/* Header Section */}
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl font-extrabold text-[#1E90FF] flex items-center justify-center gap-2">
              📜 Terms and Conditions for Pro Lead Partners
            </h1>
            <p className="text-gray-600 mt-2">Last Updated: February 2025</p>
          </div>

          {/* Terms Section */}
          <div className=" rounded-lg p-4 sm:p-6 text-gray-800 mt-6">
            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF]">
              1️⃣ Introduction
            </h2>
            <p className="mt-2">
              Welcome to LeadGenPro. By accessing or using our services, you
              agree to be bound by the following terms and conditions.
              LeadGenPro is a platform that facilitates motor insurance policy
              quotations and purchases through authorized POSP partners.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF]">
            2️⃣  Roles and Responsibilities
            </h2>
            <p className="mt-2">
              1.1. Your primary role is to generate and submit accurate leads
              for potential motor insurance customers.
            </p>
            <p className="mt-2">
              1.2. Fake leads will result in account termination and forfeiture
              of pending activity points. ❌
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            3️⃣ Activity Points Structure
            </h2>
            <p className="mt-2">
              2.1. 💰 Commissions are granted only after successful policy
              purchases.
            </p>
            <p className="mt-2">
              2.2. The activity points rate varies based on policy type and
              premium.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            4️⃣ Payment Terms
            </h2>
            <p className="mt-2">
              3.1. Payments are processed in two cycles: 1st-15th & 16th-30th.
              📆
            </p>
            <p className="mt-2">
              3.2. Payments occur only after lead verification.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            5️⃣ Data Privacy & Confidentiality
            </h2>
            <p className="mt-2">
              4.1. 🔒 Customer data must remain confidential.
            </p>
            <p className="mt-2">
              4.2. Misuse will result in termination and possible legal action.
            </p>
            <p className="mt-2">4.3. LeadGenPro may audit compliance.</p>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            6️⃣ Account Termination
            </h2>
            <p className="mt-2">
              5.1. ⚠️ Grounds for termination include fraudulent leads, data
              misuse, and policy violations.
            </p>
            <p className="mt-2">
              5.2. You may request termination via the platform’s contact form.
            </p>
            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            7️⃣ Services Provided
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                LeadGenPro connects customers with reputed insurance providers
                for motor insurance needs.
              </li>
              <li>
                Customers receive multiple quotations through the platform and
                can select the policy that suits their requirements.
              </li>
              <li>
                Policy issuance is handled by authorized POSP partners and
                LeadGenPro manages the process from payment to policy delivery
              </li>
            </ul>
            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            8️⃣ Platform Ownership & Rights
            </h2>
            <p className="mt-2">
              6.1. 🔑 LeadGenPro owns all platform resources.
            </p>
            <p className="mt-2">
              6.2. Unauthorized redistribution or misuse is prohibited.
            </p>
            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            9️⃣ Payment Terms
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                Payments are processed through LeadGenPro's secure payment
                gateway (e.g., Cashfree).
              </li>
              <li>
                Customers must ensure that they have sufficient funds to
                complete the transaction.
              </li>
              <li>
                Payment confirmation will be sent to the registered email or
                mobile number provided during the process.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            🔟 Policy Issuance and Delivery
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                Upon successful payment, the selected insurance policy will be
                issued through the authorized POSP partner.
              </li>
              <li>
                Policy documents will be uploaded to the Pro Lead Partner's
                dashboard, and it is their responsibility to share the same with
                the customer.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣1️⃣  Refund and Cancellation
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                Policy cancellations and refunds will follow the respective
                insurance company's terms and conditions.
              </li>
              <li>
                LeadGenPro will assist in initiating the cancellation or refund
                process but holds no responsibility for the final decision or
                timeline set by the insurance provider.
              </li>
              <li>
                Any processing fees applicable will be deducted from the refund
                amount.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣2️⃣Dispute Resolution
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                In case of any disputes regarding the policy, the customer must
                contact the insurance provider directly.
              </li>
              <li>
                LeadGenPro will support dispute resolution as per IRDAI
                guidelines but is not responsible for resolving claims or
                policy-related disputes.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣3️⃣ Data Privacy and Security
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                LeadGenPro ensures the confidentiality and security of customer
                data. All personal and vehicle information will be encrypted and
                shared only with authorized insurance providers.
              </li>
              <li>
                Customers must maintain the confidentiality of their login
                credentials. LeadGenPro will not be liable for unauthorized
                access caused by the customer's negligence.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣4️⃣Limitations of Liability
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                LeadGenPro acts as an intermediary platform and is not liable
                for delays, errors, or omissions caused by the insurance
                provider.
              </li>
              <li>
                The platform is not responsible for policy rejections due to
                incorrect or incomplete data submitted by the customer.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣5️⃣Legal Compliance
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                LeadGenPro operates in compliance with the Insurance Act, 1938,
                and IRDAI guidelines.
              </li>
              <li>
                Customers must abide by the applicable laws and regulations when
                using the platform.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣6️⃣ Amendments to Terms
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                LeadGenPro reserves the right to modify these terms and
                conditions at any time.
              </li>
              <li>
                Updated terms will be communicated via email or published on the
                platform.
              </li>
              <li>
                Continued use of the platform constitutes acceptance of the
                revised terms.
              </li>
            </ul>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣7️⃣Customer Responsibility
            </h2>
            <ul className="list-disc pl-5 text-gray-700">
              <li>
                Customers must provide accurate and complete vehicle details,
                such as registration number, make, model, and previous policy
                details if applicable.
              </li>
              <li>
                Customers are responsible for ensuring the validity and authentication
                 of the information shared on the platform.
              </li>
              <li>
                Any discrepancies in the data provided may lead to rejection of
                the policy or other liabilities for which LeadGenPro will not be
                responsible.
              </li>
            </ul>
            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣8️⃣ Dispute Resolution
            </h2>
            <p className="mt-2">
              7.1. Any disputes must be reported within 15 days. 🕒
            </p>
            <p className="mt-2">7.2. LeadGenPro’s decision is final.</p>

            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            1️⃣9️⃣ Changes to the Agreement
            </h2>
            <p className="mt-2">
             LeadGenPro may modify these terms at any time.
            </p>
            <p className="mt-2">
             Updates will be communicated via email or platform
              notifications.
            </p>
            <h2 className="text-lg sm:text-xl font-semibold text-[#1E90FF] mt-4">
            2️⃣0️⃣ Contact Information
            </h2>
            <p className="mt-2">
            For any queries or concerns, customers can contact LeadGenPro at
            </p>
            <p className="text-lg sm:text-xl font-bold">
      Email:{" "}
      <a
        href="mailto:support@leadgenpro.co.in"
        className="text-blue-900 hover:text-[#1E90FF] text-[#1E90FF]"
      >
        support@leadgenpro.co.in
      </a>
    </p>
          </div>

          {/* Buttons */}
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-4">
            {localStorage.getItem("from") === "account" ? (
              <button
                onClick={() => {
                  navigate(routes.account);
                  localStorage.removeItem("from");
                }}
                className="bg-blue-500 hover:bg-[white] hover:underline hover:text-[#0870F9] text-white font-semibold py-2 px-4 rounded-lg transition"
              >
                Back to Account page
              </button>
            ) : (
              <button
                onClick={() => navigate(routes.signin)}
                className="bg-blue-500 hover:bg-[white] hover:underline hover:text-[#0870F9] text-white font-semibold py-2 px-4 rounded-lg transition"
              >
                Back to signin
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
